/**************************************
 ** AtlasSphereRefinement
 *
 *
 ***************************************/
define('atlas/AtlasSphereRefinement', ['atlas/AtlasViewer', 'atlas/AtlasConstants'], function(AtlasViewer, Constants) {
    'use strict';

    var AtlasSphereRefinement = function(sphere) {
        this._sphere = sphere;
        this._currentImageList = [];
        this._currentImageMap = {};
        this._refinedImageList = [];
        this._refinedImageMap = {};
        this._refinements = {
            latitudeRefinements: [],
            longitudeRefinements: []
        };
    };

    AtlasSphereRefinement.prototype.getRefinedImageList = function() {
        return this._refinedImageList;
    };

    AtlasSphereRefinement.prototype.getTopLatitudeRefinement = function() {
        return this._topLatitudeRefinement;
    };

    AtlasSphereRefinement.prototype.getBottomLatitudeRefinement = function() {
        return this._bottomLatitudeRefinement;
    };

    /////////////////////////////////////////////////////////////////////
    //      |                   Longs                                   |
    //Lats  | 0| 1| 2| 3| 4| 5| 6| 7| 8| 9|10|11|12|13|14|15|16|17|18|19|
    //------|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|
    //I,J,K | 1|  |  |  | 1|  |  |  | 1|  |  |  | 1|  |  |  | 1|  |  |  |
    //I,J,K | 1|  | 2|  | 1|  | 2|  | 1|  | 2|  | 1|  | 2|  | 1|  | 2|  |
    //I,J,K | 1| 3| 2|  | 1| 3| 2|  | 1| 3| 2|  | 1| 3| 2|  | 1| 3| 2|  |
    //I,J,K | 1| 3| 2| 4| 1| 3| 2| 4| 1| 3| 2| 4| 1| 3| 2| 4| 1| 3| 2| 4|

    AtlasSphereRefinement.prototype.refine = function(latitudes, longitudes) {
        //contains just the new images from this refinement that are not in the current image list
        this._refinedImageList = [];
        this._refinedImageMap = {};

        //calculate the top and bottom latitudes for this refinement - assume they are in order
        this._topLatitudeRefinement = latitudes[0];
        this._bottomLatitudeRefinement = latitudes[latitudes.length - 1];


        //set the image latitude to the first one you hit going down
        //set the image longitude to the one to the left until hit a new one, e.g
        /////////////////////////////////////////////////////////////////////
        //  |                   Longs                                   |
        //Lats  | 0| 1| 2| 3| 4| 5| 6| 7| 8| 9|10|11|12|13|14|15|16|17|18|19|
        //------|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|--|
        //I     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //I     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //I     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //I     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //I     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //I     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //I     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //I     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //I     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //J     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //K     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //K     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        //K     | A| a| a| a| B| b| b| b| C| c| c| c| D| d| d| d| E| e| e| e|
        var current = 0;
        for (var lats = 0; lats < this._sphere._latitudes; ++lats) {
            if (Constants.latitudeMarkers[lats] <= latitudes[current]) {
                this._refinements.latitudeRefinements.push(latitudes[current]);
            } else {
                if (current < (latitudes.length - 1)) {
                    current++;
                }
                this._refinements.latitudeRefinements.push(latitudes[current]);
            }
        }

        if (longitudes.length === 1) {
            for (var longs = 0; longs < this._sphere._longitudes; ++longs) {
                this._refinements.longitudeRefinements.push(longitudes[0]);
            }
        } else {
            current = 1;
            for (var longs = 0; longs < this._sphere._longitudes; ++longs) {
                if (Constants.longitudeMarkers[longs] < longitudes[current]) {
                    this._refinements.longitudeRefinements.push(longitudes[current - 1]);
                }
                else {
                    this._refinements.longitudeRefinements.push(longitudes[current]);
                    if (current < (longitudes.length - 1)) {
                        current++;
                    }
                }
            }
        }

        this._populateRefinedImageList();
    };

    AtlasSphereRefinement.prototype._populateRefinedImageList = function() {
        //calculate what the new image mapping would be
        for (var f = 0; f < this._sphere.getSphereCellCount(); ++f) {
            //build the new index
            var cell = this._sphere.getSphereCellForFace(f);

            var newImageIndex = this._refinements.latitudeRefinements[cell.latitude] + this._refinements.longitudeRefinements[cell.longitude];

            //populate with the original image structure
            if ((typeof this._currentImageMap[newImageIndex] === 'undefined') &&
                (typeof this._refinedImageMap[newImageIndex] === 'undefined')) {
                //image does not exist adding
                this._refinedImageList.push(this._sphere.getSphereCellForIndex(newImageIndex));
                this._refinedImageMap[newImageIndex] = this._refinedImageList.length - 1;
            } else {
                //image already exists
            }
        }
    };

    AtlasSphereRefinement.prototype.applyRefinements = function() {
        var viewer = AtlasViewer.getInstance();
        var imageIndex = viewer.getCurrentImageIndex();

        //update the sphere with the current image mapping
        var faces = this._sphere.getSphereCellCount();
        for (var f = 0; f < faces; ++f) {
            //build the new index
            var cell = this._sphere.getSphereCellForFace(f);

            var newImageIndex = this._refinements.latitudeRefinements[cell.latitude] + this._refinements.longitudeRefinements[cell.longitude];

            //map face to new index
            this._sphere.mapFaceToImageIndex(f, newImageIndex);
        }

        //in order to stop the crawl we need to store the currently selected image
        if (imageIndex) {
            viewer.scrollToImageIndex(imageIndex, false);
        }

        this._mergeImageLists();
    };

    AtlasSphereRefinement.prototype._mergeImageLists = function() {
        for (var a = 0; a < this._refinedImageList.length; ++a) {
            if (!this._currentImageMap[this._refinedImageList[a].imageIndex]) {
                this._currentImageList.push(this._refinedImageList[a]);
                this._currentImageMap[this._refinedImageList[a].imageIndex] = (this._currentImageList.length - 1);
            }
        }

        this._refinedImageList = [];
        this._refinements.latitudeRefinements = [];
        this._refinements.longitudeRefinements = [];
    };

    return AtlasSphereRefinement;
});
